import api from '.';
import { CivilJobList } from '../pages/MasterData/CivilJobList/civilJobListSlice';

interface ReturnTypeCivilJobList {
  data: CivilJobList[];
}

export async function getCivilJobLists(): Promise<ReturnTypeCivilJobList> {
  const { data } = await api.get('/civil-job-lists');

  return data;
}
